import { genericGet } from "../../../services/api.service";
import { EntityConfig } from "../../..";

export const NaoConformidadesClientesConfig: EntityConfig = [
  {
    id: 'id',
    label: 'Id',
    type: 'id',
    nonEditable: true
  },
  {
    id: 'referencia',
    label: 'Referência',
    type: 'id',
    nonEditable: true
  },
  {
    id: 'obra',
    label: 'Obra',
    type: 'select',
    filterable: true,
    options: {
      name: 'Obra',
      route: 'obra',
      value: 'id',
      label: 'number',
      getter: () => genericGet('/findByFilter/obras'),
      searcheable: true
    }
  },
  {
    id: 'entrega',
    label: 'Entrega',
    type: 'select',
    routable: true,
    options: {
      name: 'Entrega',
      route: 'entrega',
      value: 'id',
      label: 'publicDeliveryDate',
      triggeredGetter: async (i: any) => (await genericGet(`/obras/${i}/entregas`)).data, // function to trigger according to other form parameter
      triggerParam: 'obra', // Form parameter used to build getterfunction
      searcheable: true
    }
  },
  {
    id: 'pecaEntrega',
    label: 'Peça',
    type: 'select',
    routable: true,
    options: {
      name: 'Peça Entrega',
      route: 'peca',
      value: 'id',
      label: 'peca.reference',
      triggeredGetter: (i: any) => genericGet(`/obras/${undefined}/entregas/${i}/pecas-entrega`), // function to trigger according to other form parameter
      triggerParam: 'entrega', // Form parameter used to build getterfunction
      searcheable: true
    },
  },
  {
    id: 'aceite',
    label: 'Aceite',
    type: 'boolean',
  },
  {
    id: 'causaParaNaoConformidade',
    label: 'Causa para não conformidade',
    type: 'text',
    options: {
      isMultiLine: true
    }
  },
  {
    id: 'acoesDeMelhoria',
    label: 'Ações de melhoria',
    type: 'text',
    options: {
      isMultiLine: true
    }
  },
  {
    id: 'anexos',
    label: 'Documentos anexos',
    type: 'anexos',
    options: {
      anexosEndpointBuildFunction: (id: number | string) => `/nao-conformidades-clientes/${id}/anexos`
    }
    
  },
  // {
  //   id: 'value',
  //   label: 'Valor',
  //   type: 'number',
  //   displayInfo: 'currency'
  // },
  // {
  //   id: 'faturacaoADescontar',
  //   label: 'Fatura a descontar',
  //   type: 'select',
  //   filterable: true,
  //   options: {
  //     name: 'Fatura',
  //     route: 'faturacaoClientes',
  //     value: 'id',
  //     label: 'code',
  //     displayInfo: [{ name: 'Fatura', label: 'code' }, { name: 'Valor', label: 'value', type: 'currency' }],
  //     // getter: ()=>genericGet('/findByFilter/faturacao-clientes'),
  //     triggeredGetter: (i: number) => genericGet(`/faturacao-clientes/unpaid/${i}`), // function to trigger according to other form parameter
  //     triggerParam: 'client', // Form parameter used to build getterfunction
  //     searcheable: true

  //   }
  // },
  // {
  //   id: 'used',
  //   label: 'Usada',
  //   type: 'boolean',
  //   filterable: true,

  // }
];
